import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'html2canvas';
import { memberPortal } from "../member-portal";
import 'jsPDF';

export class memberStatement {
	private stmForm:any   = $('#members-statement-form');
	private memberBase:any = new memberPortal();
	private filtered10Data:any;

	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.stmForm.find('select'));

		_self.memberBase.initSelectizeInputs(inputSelectArr);
	}

	initTables(): any {
		let _self = this;
		let stateCoordinatorTable = $('#members-statement-table');
		let selctPerd = _self.stmForm.find('#miles-period-select').val();
		
		let period:any;
		let monthJanFeb:any;
		if(selctPerd!=null && selctPerd!=""){
			period=selctPerd.substr(selctPerd.length-4);
			monthJanFeb=period.split(" ")[1];
		}
		
			
			if(period!=null && period!="" && parseInt(period)>=2021)	{
				if(parseInt(period)==2021 && monthJanFeb!=null && monthJanFeb!="" && (monthJanFeb=="February" || monthJanFeb=="January")){
					
		//$(".elite-sectors-earned").css('display', '');
		$(".elite-sectors-earned").removeClass('hidden');
		stateCoordinatorTable.DataTable({
			responsive: true,
			paging: true,
			info: false,
			searching: false,
			dom: 'frtipl',
			columns: [
			{
				title: 'Activity Date',
				data: {
					_: 'date.display',
					sort: 'date.timestamp'
				},
				class: 'date'
			},
			{
				title: 'Month',
				data: 'month',
				class: 'month hidden'
			},
			{
				title: 'Description',
				data: 'activity',
				class: 'activity'
			},
			{
				title: 'Enrich Miles Credited',
				data: 'milesEarned',
				class: 'miles-earned'
			},
			{
				title: 'Enrich Miles Debited',
				data: 'milesRedeemed',
				class: 'miles-redeemed'
			},
			{
				title: 'Elite Miles Earned',
				data: 'eliteMilesEarned',
				class: 'elite-miles-earned'
			},
			{
				title: 'Elite Sectors Earned',
				data: 'eliteSectorsEarned',
				class: 'elite-sectors-earned'
			}
			],
			columnDefs: [{
				"targets": 'no-sort',
				"orderable": false,
			}]
		});
		let statementTable = $.fn.dataTable.Api('#members-statement-table');
		_self.statementTableFilter();
		_self.initPrintBtn();
		$.fn.dataTableExt.sErrMode = "console";
        $.fn.dataTable.ext.errMode = 'none';
				}
				else{
				//$(".elite-sectors-earned").css('display', 'none');
				$(".elite-sectors-earned").addClass("hidden");
		stateCoordinatorTable.DataTable({
			responsive: true,
			paging: true,
			info: false,
			searching: false,
			dom: 'frtipl',
			columns: [
			{
				title: 'Activity Date',
				data: {
					_: 'date.display',
					sort: 'date.timestamp'
				},
				class: 'date'
			},
			{
				title: 'Month',
				data: 'month',
				class: 'month hidden'
			},
			{
				title: 'Description',
				data: 'activity',
				class: 'activity'
			},
			{
				title: 'Enrich Points Credited',
				data: 'milesEarned',
				class: 'miles-earned'
			},
			{
				title: 'Enrich Points Debited',
				data: 'milesRedeemed',
				class: 'miles-redeemed'
			},
			{
				title: 'Elite Points Earned',
				data: 'eliteMilesEarned',
				class: 'elite-miles-earned'
			}/*,
			{
				title: 'Elite Sectors Earned',
				data: 'eliteSectorsEarned',
				class: 'elite-sectors-earned'
			}*/
			],
			columnDefs: [{
				"targets": 'no-sort',
				"orderable": false,
			}]
		});
		let statementTable = $.fn.dataTable.Api('#members-statement-table');
		_self.statementTableFilter();
		_self.initPrintBtn();
		$.fn.dataTableExt.sErrMode = "console";
        $.fn.dataTable.ext.errMode = 'none';
	}
	}else{
		//$(".elite-sectors-earned").css('display', '');
		$(".elite-sectors-earned").removeClass('hidden');
		stateCoordinatorTable.DataTable({
			responsive: true,
			paging: true,
			info: false,
			searching: false,
			dom: 'frtipl',
			columns: [
			{
				title: 'Activity Date',
				data: {
					_: 'date.display',
					sort: 'date.timestamp'
				},
				class: 'date'
			},
			{
				title: 'Month',
				data: 'month',
				class: 'month hidden'
			},
			{
				title: 'Description',
				data: 'activity',
				class: 'activity'
			},
			{
				title: 'Enrich Miles Credited',
				data: 'milesEarned',
				class: 'miles-earned'
			},
			{
				title: 'Enrich Miles Debited',
				data: 'milesRedeemed',
				class: 'miles-redeemed'
			},
			{
				title: 'Elite Miles Earned',
				data: 'eliteMilesEarned',
				class: 'elite-miles-earned'
			},
			{
				title: 'Elite Sectors Earned',
				data: 'eliteSectorsEarned',
				class: 'elite-sectors-earned'
			}
			],
			columnDefs: [{
				"targets": 'no-sort',
				"orderable": false,
			}]
		});
		let statementTable = $.fn.dataTable.Api('#members-statement-table');
		_self.statementTableFilter();
		_self.initPrintBtn();
		$.fn.dataTableExt.sErrMode = "console";
        $.fn.dataTable.ext.errMode = 'none';
	}


		
	}

	statementTableFilter(): any {
		let _self = this;
		let statementSelect = _self.stmForm.find('#miles-period-select')[0].selectize;
		let statementTable = $.fn.dataTable.Api('#members-statement-table');
		let period:any;
		// sort by reverse year on load table
		statementTable.order( [[ 0, 'desc' ]] ).draw();

		// filter statement table based on month value (first column)
		statementSelect.on('change', function(val:any){
			var data={'selectedValue':val};
			$.ajax({
				type : 'POST',
				url : '/bin/services/new/retrievestatements',
				data : data,
				success : function(msg:any) {
					_self.redirectUser(msg);
					var json = JSON.parse(msg);
					var jsnLen=json.length;
					statementTable.clear().draw();
					if(jsnLen>0){
						//alert("jsnLen>0");
						for (var i = 0, len = json.length; i < len; i++) {
							var formattedRow = formatOutputDatarow(json[i],val);
							populateTableData(statementTable, formattedRow);
						}
					}else{
						//alert("else...jsnLen");
						var formattedRow = formatOutputDatarow(json[i],val);
						populateTableData(statementTable, formattedRow);
					}
					statementTable.column(1).search(val).draw();
					if ($("#members-statement-table .dataTables_empty").length || val == "") {
						$(".miles-export-action .btn").attr("disabled", "disabled");
					} else {
						$(".miles-export-action .btn").removeAttr("disabled");
					}
				},
				error : function(error:any) {
				}
			});
		});

		function formatOutputDatarow(rawData:any,period:any) {
			let monthJanFeb:any;
			if(period!=null){
				monthJanFeb=period.split(" ")[1];
				period=period.substr(period.length-4);
			}
			
			if(period!=null && parseInt(period)>=2021){

				if(parseInt(period)==2021 && monthJanFeb!=null && monthJanFeb!="" && (monthJanFeb=="February" || monthJanFeb=="January")){
			let milesEarnedOld="Enrich Miles Earned";
			let milesRedemdOld="Enrich Miles Redeemed";
			let elitesEarnedOld="Elite Miles Earned";
			//$(".elite-sectors-earned").css('display', '');
			$(".elite-sectors-earned").removeClass('hidden');
			$(".miles-earned-header").text(milesEarnedOld);
			$(".miles-redeemed-header").text(milesRedemdOld);
			$(".elite-miles-earned-header").text(elitesEarnedOld);
			var formattedData2 = {
				date: {
					display: rawData.activityDate,
					timestamp: rawData.timeLongValue
				},
				month: rawData.statementSeq,
				activity: rawData.definition,
				milesEarned: rawData.miles,
				milesRedeemed: rawData.redeemedMiles,
				eliteMilesEarned: rawData.point,
				eliteSectorsEarned: rawData.fltCount,
			};
			$.fn.dataTableExt.sErrMode = "console";
       		$.fn.dataTable.ext.errMode = 'none';
			return formattedData2;
				}
				else{
				//alert("if...2021");
				let milesEarned="Enrich Points Earned";
				let milesRedemd="Enrich Points Redeemed";
				let elitesEarned="Elite Points Earned";
				//$(".elite-sectors-earned").css('display', 'none');
				$(".elite-sectors-earned").addClass("hidden");
				$(".miles-earned-header").text(milesEarned);
				$(".miles-redeemed-header").text(milesRedemd);
				$(".elite-miles-earned-header").text(elitesEarned);
				$.fn.dataTableExt.sErrMode = "console";
       			$.fn.dataTable.ext.errMode = 'none';
			var formattedData = {
				date: {
					display: rawData.activityDate,
					timestamp: rawData.timeLongValue
				},
				month: rawData.statementSeq,
				activity: rawData.definition,
				milesEarned: rawData.miles,
				milesRedeemed: rawData.redeemedMiles,
				eliteMilesEarned: rawData.point,
				//eliteSectorsEarned: rawData.fltCount,
			};
			$.fn.dataTableExt.sErrMode = "console";
       		$.fn.dataTable.ext.errMode = 'none';
			return formattedData;
		}
		}else{
			//alert("else 2020");
			let milesEarnedOld="Enrich Miles Earned";
			let milesRedemdOld="Enrich Miles Redeemed";
			let elitesEarnedOld="Elite Miles Earned";
			//$(".elite-sectors-earned").css('display', '');
			$(".elite-sectors-earned").removeClass('hidden');
			$(".miles-earned-header").text(milesEarnedOld);
			$(".miles-redeemed-header").text(milesRedemdOld);
			$(".elite-miles-earned-header").text(elitesEarnedOld);
			var formattedData2 = {
				date: {
					display: rawData.activityDate,
					timestamp: rawData.timeLongValue
				},
				month: rawData.statementSeq,
				activity: rawData.definition,
				milesEarned: rawData.miles,
				milesRedeemed: rawData.redeemedMiles,
				eliteMilesEarned: rawData.point,
				eliteSectorsEarned: rawData.fltCount,
			};
			$.fn.dataTableExt.sErrMode = "console";
       		$.fn.dataTable.ext.errMode = 'none';
			return formattedData2;
		}
		}
		function populateTableData(el:any, data:any) {
			el.row.add(data).draw();
		}

	}

	initPrintBtn(): any {
		let _self = this;
		let printBtn = _self.stmForm.find('#members-statement-download-btn');
		let statementSelect = _self.stmForm.find('#miles-period-select')[0].selectize;
		let statementTable = $.fn.dataTable.Api('#members-statement-table');
		let statementTableContainer = $('#members-statement-table_wrapper');

		printBtn.click((e:any) => {
			e.preventDefault();
			e.stopPropagation();

			// // if (statementSelect.$activeOption !== null) {
			// 	// show all rows in table
				statementTable.page.len(-1).draw();

			// 	// let wo = window.open();
			// 	// wo.document.write(document.documentElement.innerHTML);
			// 	// wo.document.body.classList.add('members--print-statement');

			// 	// print div
			$('body').addClass('members--print-statement');

			let pdf = new jsPDF('p','pt','a4');
			pdf.internal.scaleFactor = 2;
			let options = {
				pagesplit: true
			};

			pdf.addHTML(document.body, 0, 0, options, function() {
				pdf.save('enrich-statement.pdf');
			});
			$('body').removeClass('members--print-statement');


				// window.print();
			// }
		});
	}

	redirectUser(msg:any) {
		if (msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-","");
			window.location.href = msg;
		}
	}
}

let scope:Element = document.querySelector('#members-statement-form');

if (scope) {
	try {
		let memberstatement = new memberStatement();
		memberstatement.initSelectizeInputs();
		memberstatement.initTables();	

	
	} catch(e) {console.error(e);}
}

